import moment from 'moment';

export const INDEX_DB_NAME = localStorage.getItem('storeName')
export const CURRENT_VERSION = 2
export const INDEX_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss'
export const INDEX_DB_TABLES = {
  PRODUCTS: 'products',
  ENTITIESSYNCCCOUNT: 'entitiesSyncCount',
  SALES: 'sales',
  SALEATTRIBUTES: 'sellattributes',
  SALE_PAY: 'sale_pay',
  SALEATTRIBUTEGROUPS: 'sellattributegroups',
  CUSTOMERS: 'customerprofiletable',
  CUSTOMERGROUPS: 'customergroup',
  SALESTAXES: 'salestaxes',
  SALESTAXGROUPS: 'salestaxgroups',
  BRANDS: 'brands',
  PRODUCTTYPES: 'producttypes',
  PRODUCTTAGS: 'producttags',
  STOREOUTLETS: 'storeoutlets',
  PAYMENTTYPES: 'paymenttypes',
  PRICEBOOKS: 'pricebooks',
  SALEPRODUCTS: 'saleproducts',
  STORECONFIGURATIONS: 'storeconfigurations',
  SALETAXASSIGNEDOUTLET: 'salestaxassignedoutlet',
  PROMOTIONS: 'promotions',
  OUTLETREGISTERS: 'outletregisters',
  CONFIGDATA: 'configdata',
  PRINTERS: 'printers',
  SUPPLIER: 'supplier'
}

//#region Products

export const PRODUCT_KEY_PATH = 'productID'
export const INDEX_DB_PRODUCTS_COLUMNS = {
  PRODUCT_ID: 'productID',
  PRODUCT_NAME: 'productName'
}
export const PRODUCT_NAME_INDEX = 'product_id'

//#endregion

//#region Sale Products

export const SALE_PRODUCT_KEY_PATH = 'productID'
export const INDEX_DB_SALE_PRODUCTS_COLUMNS = {
  PRODUCT_ID: 'productID',
  PRODUCT_NAME: 'productName'
}
export const SALE_PRODUCT_NAME_INDEX = 'sale_product_name'

//#endregion

//#region Entites Sync Index
export const ENTITY_KEY_PATH = 'tableName'
export const ENTITY_NAME_INDEX = 'table_name'

export const INDEX_DB_ENTITIES_COLUMNS = {
  TABLENAME: 'tableName',
  ROWSCOUNT: 'rowsCount'
}

export const IndexDBSyncIntervalTime = '5*60*1000'

//#endregion

//#region Sell Attributes

// export const SALE_ATTRIBUTE_KEY_PATH = "sellAttributeID";
export const SALE_ATTRIBUTE_KEY_PATH = 'id'
export const INDEX_DB_SALE_ATTRIB_COLUMNS = {
  SALE_ATTRIB_ID: 'sellAttributeID',
  ID: 'id'
}
export const SALE_ATTRIB_NAME_INDEX = 'sale_attrib_index_id'

//#endregion

//#region   Sell Attributes Groups
export const SALE_ATTRIBUTE_GROUP_KEY_PATH = 'sellAttributeGroupID'
export const INDEX_DB_SALE_ATTRIB_GROUP_COLUMNS = {
  SALE_ATTRIB_GRP_ID: 'sellAttributeGroupID',
  ID: 'id'
}
export const SALE_ATTRIB_GROUP_NAME_INDEX = 'sale_attrib_group_index_id'
//#endregion

//#region   Customers
export const CUSTOMER_KEY_PATH = 'customerProfileId'
export const INDEX_DB_CUSTOMER_COLUMNS = {
  CUSTOMER_ID: 'customerProfileId',
  ID: 'id'
}
export const CUSTOMER_NAME_INDEX = 'customer_name_index'
//#endregion

//#region   Customer Groups
export const CUSTOMER_GROUP_KEY_PATH = 'customerGroupId'
export const INDEX_DB_CUSTOMER_GROUP_COLUMNS = {
  CUSTOMER_GROUP_ID: 'customerGroupId',
  ID: 'id'
}
export const CUSTOMER_GROUP_NAME_INDEX = 'customer_group_index'
//#endregion

//#region  Sales Taxes
export const SALES_TAX_KEY_PATH = 'saleTaxID'
export const INDEX_DB_SALES_TAXES_COLUMNS = {
  SALE_TAX_ID: 'saleTaxID',
  ID: 'id'
}
export const SALE_TAX_INDEX = 'sale_tax'
//#endregion

//#region  Sales Tax Groups
export const SALES_TAX_GROUP_KEY_PATH = 'salesTaxGroupID'
export const INDEX_DB_SALES_TAXES_GROUP_COLUMNS = {
  SALE_TAX_GROUP_ID: 'salesTaxGroupID',
  ID: 'id'
}
export const SALE_TAX_GROUP_INDEX = 'sale_tax_group'
//#endregion

//#region Brands
export const BRAND_KEY_PATH = 'brandID'
export const INDEX_DB_BRAND_COLUMNS = {
  BRAND_ID: 'brandID',
  ID: 'id'
}
export const BRAND_INDEX = 'brand_name'
//#endregion

//#region PRODUCT TYPES
export const PRODUCT_TYPE_KEY_PATH = 'productTypeID'
export const INDEX_DB_PRODUCT_TYPE_COLUMNS = {
  PRODUCT_TYPE_ID: 'productTypeID',
  ID: 'id'
}
export const PRODUCT_TYPE_INDEX = 'product_type'
//#endregion

//#region Product Tags
export const PRODUCT_TAG_KEY_PATH = 'productTagID'
export const INDEX_DB_PRODUCT_TAG_COLUMNS = {
  PRODUCT_TAG_ID: 'productTagID',
  ID: 'id'
}
export const PRODUCT_TAG_INDEX = 'product_tag'
//#endregion

//#region Store Outlets
export const STORE_OUTLETS_KEY_PATH = 'storeOutletID'
export const INDEX_DB_STORE_OUTLETS_COLUMNS = {
  STORE_OUTLET_ID: 'storeOutletID',
  ID: 'id'
}
export const STORE_OUTLETS_INDEX = 'store_outlets'
//#endregion

//#region Payment Types
export const PAYMENT_TYPES_KEY_PATH = 'paymentTypeID'
export const INDEX_DB_PAYMENT_TYPES_COLUMNS = {
  PAYMENT_TYPE_ID: 'paymentTypeID',
  ID: 'id'
}
export const PAYMENT_TYPES_INDEX = 'payment_types_index'

//#endregion

//#region Pricebooks
export const PRICE_BOOK_KEY_PATH = '_PriceBookID'
export const INDEX_DB_PRICE_BOOK_COLUMNS = {
  PRICE_BOOK_ID: '_PriceBookID'
}
export const PRICE_BOOK_INDEX = 'price_book_index'

//#endregion

//#region Products

export const PROMOTION_KEY_PATH = 'd_PromotionID'
export const INDEX_DB_PROMOTION_COLUMNS = {
  PROMOTION_ID: 'd_PromotionID'
}
export const PROMOTION_INDEX = 'sale_promotions'

//#endregion

//#region Store Configuration
export const STORE_CONFIGURATION_KEY_PATH = 'storeConfigurationID'
export const INDEX_DB_STORE_CONFIGURATION_COLUMNS = {
  STORE_CONFIGURATION_ID: 'storeConfigurationID'
}
export const STORE_CONFIGURATION_INDEX = 'store_configuration_index'

//#endregion

//#region Sale Tax Assigned Outlets
export const SALES_TAX_ASSIGNED_OUTLET_KEY_PATH = 'salesTaxAssignedOutletID'
export const INDEX_DB_SALES_TAX_ASSIGNED_OUTLET_COLUMNS = {
  SALE_TAX_ASSIGNED_OUTLET_ID: 'salesTaxAssignedOutletID'
}
export const SALES_TAX_ASSIGNED_OUTLET_INDEX = 'sales_tax_assigned_outlet_index'

//#endregion

//#region Outlet Registers
export const OUTLET_REGISTER_KEY_PATH = 'outletRegisterID'
export const INDEX_DB_OUTLET_REGISTERS_COLUMNS = {
  OUTLET_REGISTER_ID: 'outletRegisterID'
}
export const OUTLET_REGISTER_INDEX = 'outlet_registers'

//#endregion

//#region PRINTERS
export const PRINTER_KEY_PATH = 'printerID'
export const INDEX_DB_PRINTERS_COLUMNS = {
  PRINTER_ID: 'printerID'
}
export const PRINTER_INDEX = 'printers'

//#endregion

export const PRODUCT_INDEX_KEY = 'attributeID'
export const SALE_NAME_INDEX = 'sale_index_id'
export const SALE_CASH_NAME_INDEX = 'sale_cash_index_id'

export const INDEX_DB_SALE_COLUMNS = {
  SALE_ID: 'salesOrderID'
}
export const INDEX_DB_SALE_CASH_COLUMNS = {
  SALE_CASH_ID: 'saleCashID'
}

//#region Sales
export const SALE_PAY_NAME_PK = 'indexKey'
export const SALE_PAY_INDEX_SALES = 'indexKey'
export const SALE_NAME_PK = 'indexKey'
//#endregion

//#region Outlet Registers
export const CONFIG_KEY_PATH = 'config_key'
export const CONFIG_KEY_COLUMNS = {
  CONFIG_KEY_ID: 'config_key'
}
export const CONFIG_INDEX = 'config_key'
//#endregion

export const INDEX_DB_STORE_CONFIG = [
  {
    tableName: INDEX_DB_TABLES.ENTITIESSYNCCCOUNT,
    keyPath: ENTITY_KEY_PATH,
    options: { autoIncrement: true },
    indexes: [
      {
        name: ENTITY_NAME_INDEX,
        keyPath: INDEX_DB_ENTITIES_COLUMNS.TABLENAME,
        unique: true
      }
    ]
  },
  {
    tableName: INDEX_DB_TABLES.PRODUCTS,
    keyPath: PRODUCT_KEY_PATH,
    options: { autoIncrement: true },
    indexes: [
      {
        name: PRODUCT_NAME_INDEX,
        keyPath: INDEX_DB_PRODUCTS_COLUMNS.PRODUCT_ID,
        unique: false
      }
    ]
  },
  {
    tableName: INDEX_DB_TABLES.SALEPRODUCTS,
    keyPath: SALE_PRODUCT_KEY_PATH,
    options: { autoIncrement: true },
    indexes: [
      {
        name: SALE_PRODUCT_NAME_INDEX,
        keyPath: INDEX_DB_SALE_PRODUCTS_COLUMNS.PRODUCT_ID,
        unique: false
      }
    ]
  },
  {
    tableName: INDEX_DB_TABLES.SALEATTRIBUTES,
    keyPath: SALE_ATTRIBUTE_KEY_PATH,
    options: { autoIncrement: true, unique: true },
    indexes: [
      {
        name: SALE_ATTRIB_NAME_INDEX,
        keyPath: INDEX_DB_SALE_ATTRIB_COLUMNS.ID,
        unique: true
      }
    ]
  },
  {
    tableName: INDEX_DB_TABLES.SALEATTRIBUTEGROUPS,
    keyPath: SALE_ATTRIBUTE_GROUP_KEY_PATH,
    options: { autoIncrement: true, unique: true },
    indexes: [
      {
        name: SALE_ATTRIB_GROUP_NAME_INDEX,
        keyPath: INDEX_DB_SALE_ATTRIB_GROUP_COLUMNS.SALE_ATTRIB_GRP_ID,
        unique: true
      }
    ]
  },
  {
    tableName: INDEX_DB_TABLES.CUSTOMERS,
    keyPath: CUSTOMER_KEY_PATH,
    options: { autoIncrement: true, unique: true },
    indexes: [
      {
        name: CUSTOMER_NAME_INDEX,
        keyPath: INDEX_DB_CUSTOMER_COLUMNS.CUSTOMER_ID,
        unique: true
      }
    ]
  },
  {
    tableName: INDEX_DB_TABLES.CUSTOMERGROUPS,
    keyPath: CUSTOMER_GROUP_KEY_PATH,
    options: { autoIncrement: true, unique: true },
    indexes: [
      {
        name: CUSTOMER_GROUP_NAME_INDEX,
        keyPath: INDEX_DB_CUSTOMER_GROUP_COLUMNS.CUSTOMER_GROUP_ID,
        unique: true
      }
    ]
  },
  {
    tableName: INDEX_DB_TABLES.SALESTAXES,
    keyPath: SALES_TAX_KEY_PATH,
    options: { autoIncrement: true, unique: true },
    indexes: [
      {
        name: SALE_TAX_INDEX,
        keyPath: INDEX_DB_SALES_TAXES_COLUMNS.SALE_TAX_ID,
        unique: true
      }
    ]
  },
  {
    tableName: INDEX_DB_TABLES.SALESTAXGROUPS,
    keyPath: SALES_TAX_GROUP_KEY_PATH,
    options: { autoIncrement: true, unique: true },
    indexes: [
      {
        name: SALE_TAX_GROUP_INDEX,
        keyPath: INDEX_DB_SALES_TAXES_GROUP_COLUMNS.SALE_TAX_GROUP_ID,
        unique: true
      }
    ]
  },
  {
    tableName: INDEX_DB_TABLES.BRANDS,
    keyPath: BRAND_KEY_PATH,
    options: { autoIncrement: true, unique: true },
    indexes: [
      {
        name: BRAND_INDEX,
        keyPath: INDEX_DB_BRAND_COLUMNS.BRAND_ID,
        unique: true
      }
    ]
  },
  {
    tableName: INDEX_DB_TABLES.PRODUCTTYPES,
    keyPath: PRODUCT_TYPE_KEY_PATH,
    options: { autoIncrement: true, unique: true },
    indexes: [
      {
        name: PRODUCT_TYPE_INDEX,
        keyPath: INDEX_DB_PRODUCT_TYPE_COLUMNS.PRODUCT_TYPE_ID,
        unique: true
      }
    ]
  },
  {
    tableName: INDEX_DB_TABLES.PRODUCTTAGS,
    keyPath: PRODUCT_TAG_KEY_PATH,
    options: { autoIncrement: true, unique: true },
    indexes: [
      {
        name: PRODUCT_TAG_INDEX,
        keyPath: INDEX_DB_PRODUCT_TAG_COLUMNS.PRODUCT_TAG_ID,
        unique: true
      }
    ]
  },
  {
    tableName: INDEX_DB_TABLES.STOREOUTLETS,
    keyPath: STORE_OUTLETS_KEY_PATH,
    options: { autoIncrement: true, unique: true },
    indexes: [
      {
        name: STORE_OUTLETS_INDEX,
        keyPath: INDEX_DB_STORE_OUTLETS_COLUMNS.STORE_OUTLET_ID,
        unique: true
      }
    ]
  },
  {
    tableName: INDEX_DB_TABLES.PAYMENTTYPES,
    keyPath: PAYMENT_TYPES_KEY_PATH,
    options: { autoIncrement: true, unique: true },
    indexes: [
      {
        name: PAYMENT_TYPES_INDEX,
        keyPath: INDEX_DB_PAYMENT_TYPES_COLUMNS.PAYMENT_TYPE_ID,
        unique: true
      }
    ]
  },
  {
    tableName: INDEX_DB_TABLES.PRICEBOOKS,
    keyPath: PRICE_BOOK_KEY_PATH,
    options: { autoIncrement: true, unique: true },
    indexes: [
      {
        name: PRICE_BOOK_INDEX,
        keyPath: INDEX_DB_PRICE_BOOK_COLUMNS.PRICE_BOOK_ID,
        unique: true
      }
    ]
  },
  {
    tableName: INDEX_DB_TABLES.STORECONFIGURATIONS,
    keyPath: STORE_CONFIGURATION_KEY_PATH,
    options: { autoIncrement: true, unique: true },
    indexes: [
      {
        name: STORE_CONFIGURATION_INDEX,
        keyPath: INDEX_DB_STORE_CONFIGURATION_COLUMNS.STORE_CONFIGURATION_ID,
        unique: true
      }
    ]
  },
  {
    tableName: INDEX_DB_TABLES.SALETAXASSIGNEDOUTLET,
    keyPath: SALES_TAX_ASSIGNED_OUTLET_KEY_PATH,
    options: { autoIncrement: true, unique: true },
    indexes: [
      {
        name: SALES_TAX_ASSIGNED_OUTLET_INDEX,
        keyPath:
          INDEX_DB_SALES_TAX_ASSIGNED_OUTLET_COLUMNS.SALE_TAX_ASSIGNED_OUTLET_ID,
        unique: true
      }
    ]
  },
  {
    tableName: INDEX_DB_TABLES.PROMOTIONS,
    keyPath: PROMOTION_KEY_PATH,
    options: { autoIncrement: true, unique: true },
    indexes: [
      {
        name: PROMOTION_INDEX,
        keyPath: INDEX_DB_PROMOTION_COLUMNS.PROMOTION_ID,
        unique: true
      }
    ]
  },
  {
    tableName: INDEX_DB_TABLES.SALES,
    keyPath: SALE_NAME_PK,
    options: { autoIncrement: true },
    indexes: [
      {
        name: SALE_PAY_NAME_PK,
        keyPath: SALE_PAY_NAME_PK,
        unique: false
      }
    ]
  },
  // {
  //   tableName: INDEX_DB_TABLES.SALE_PAY,
  //   keyPath: SALE_PAY_NAME_PK,
  //   options: { autoIncrement: true },
  //   indexes: [
  //     {
  //       name: SALE_PAY_INDEX_SALES,
  //       keyPath: SALE_PAY_INDEX_SALES,
  //       keyPath: INDEX_DB_SALE_ATTRIB_COLUMNS.ID,
  //       unique: true
  //     }
  //   ]
  // },
  {
    tableName: INDEX_DB_TABLES.OUTLETREGISTERS,
    keyPath: OUTLET_REGISTER_KEY_PATH,
    options: { autoIncrement: true, unique: true },
    indexes: [
      {
        name: OUTLET_REGISTER_INDEX,
        keyPath: INDEX_DB_OUTLET_REGISTERS_COLUMNS.OUTLET_REGISTER_ID,
        unique: true
      }
    ]
  },
  {
    tableName: INDEX_DB_TABLES.CONFIGDATA,
    keyPath: CONFIG_KEY_PATH,
    options: { autoIncrement: true, unique: true },
    indexes: [
      {
        name: CONFIG_INDEX,
        keyPath: CONFIG_KEY_COLUMNS.CONFIG_KEY_ID,
        unique: true
      }
    ]
  },
  {
    tableName: INDEX_DB_TABLES.PRINTERS,
    keyPath: PRINTER_KEY_PATH,
    options: { autoIncrement: true, unique: true },
    indexes: [
      {
        name: PRINTER_INDEX,
        keyPath: INDEX_DB_PRINTERS_COLUMNS.PRINTER_ID,
        unique: true
      }
    ]
  }
]
export const DURATION = moment.duration(50, 'minutes');